import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Divider, Typography } from 'antd'
import MetricCard from '../biomarker/client'
const { Paragraph } = Typography

class ClientCategory extends Component {
  static propTypes = {
    category: PropTypes.object,
    metricsField: PropTypes.string,
    turnTo: PropTypes.func
  }

  renderSubCategory(category, index) {
    const { metricsField, turnTo, ageScopes, person } = this.props
    if (!category[metricsField] || category[metricsField].length === 0) {
      return null
    }

    return (
      <div className="sub-category-container" key={index}>
        <Divider orientation="left">{category.name}</Divider>
        <div className="description">
          <Paragraph
            ellipsis={{ rows: 1.5, expandable: true }}
            index={category.id}
          >
            {category.description}
          </Paragraph>
        </div>
        <div className="card-list">
          {category[metricsField].map((item, index) => (
            <MetricCard
              key={index}
              metric={item}
              {...{ ageScopes, person, turnTo }}
            />
          ))}
        </div>
      </div>
    )
  }

  render() {
    const { category, metricsField, turnTo, ageScopes, person } = this.props

    const validSubCategories = (category.child_categories || []).filter(
      (subCat) => subCat[metricsField] && subCat[metricsField].length > 0
    )

    const hasTopLevelMetrics =
      category[metricsField] && category[metricsField].length > 0

    const shouldRenderCategory =
      hasTopLevelMetrics || validSubCategories.length > 0

    if (!shouldRenderCategory) return null

    return (
      <div className="root-category">
        <div className="description">
          <h2>{category.name}</h2>
          <Paragraph
          // ellipsis={{ rows: 1.5, expandable: true }}
          >
            {category.description}
          </Paragraph>
        </div>

        {validSubCategories.length > 0 ? (
          <div>
            {validSubCategories.map((item, index) =>
              this.renderSubCategory(item, index)
            )}
          </div>
        ) : (
          <div className="card-list">
            {hasTopLevelMetrics ? (
              category[metricsField].map((item, index) => (
                <MetricCard
                  key={index}
                  metric={item}
                  {...{ ageScopes, person, turnTo }}
                />
              ))
            ) : null}
          </div>
        )}
      </div>
    )
  }
}

export default ClientCategory
